import { FieldOption } from "components/FieldSelect/FieldSelect";
import { captureException } from "services/captureException";

export const withSelectedOption = (
	newOptions: FieldOption[],
	handler: (value: FieldOption["value"]) => void
) => {
	const selectedOption = newOptions.find(val => !!val.selected);
	if (!selectedOption) {
		throw captureException(new Error("No selected option"), {
			evtType: "noSelectedOption"
		});
	}

	handler(selectedOption.value);
};
